import { Omit } from '@material-ui/core';
import withStyles from '@material-ui/core/styles/withStyles';
import Image, { ImageProps } from '@serko/zui/es/Image/Image';
import React, { PureComponent } from 'react';
import compose from 'recompose/compose';
import { withCdn, WithCdn } from '../withCdn';

interface OwnProps extends Omit<ImageProps, 'src' | 'ref'> {
  src: Required<ImageProps>['src'];
}

export interface CdnImageProps extends OwnProps, WithCdn {}

class CdnImageBase extends PureComponent<CdnImageProps> {
  public render() {
    const {
      cdnUrls: { serkoCdn },
      src,
      ...props
    } = this.props;
    return <Image {...props} src={new URL(src, serkoCdn).toString()} />;
  }
}

const enhance = compose<CdnImageProps, OwnProps>(
  withCdn(),
  withStyles({}, { name: 'ZuiImage' }), // Logos component is expecting the element.type.options.name to be 'ZuiImage'
);

/**
 * ZUI Image extension component that uses the serko CDN url as a base uri
 */
export const CdnImage = enhance(CdnImageBase);

CdnImage.displayName = 'CdnImage';
